export default "__VITE_ASSET__1542fe0d__"